import { gql } from '@apollo/client';
import { REPORTING_REQUIREMENT_DETAIL } from '../fragments/reportingRequirement';

export const REPORTING_REQUIREMENT_DETAIL_QUERY = gql`
  query reportingRequirementDetail($id: ID!) {
    requirement: reportingRequirementDetail(id: $id) {
      ...reportingRequirementDetail
    }
  }
  ${REPORTING_REQUIREMENT_DETAIL}
`;
